import script from "./PhoneDialCodeDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneDialCodeDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneDialCodeDropdown.vue?vue&type=style&index=0&id=124c325a&scoped=true&lang=css"
import "./PhoneDialCodeDropdown.vue?vue&type=style&index=1&id=124c325a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124c325a"]])

export default __exports__